import { useContext } from "react";

import { WorkflowCommandsContext } from "@src/contexts/WorkflowCommandsContext";

export const useWorkflowCommandsContext = () =>
  useContext(WorkflowCommandsContext);
